define('features/overlayGameLauncher/stats/gems/gemsViewModel',[
    'knockout',
    'underscore'
], function (ko, _) {

    return function GemsViewModel (newAdventure, itemManager, parentView) {

        var self = this;

        self.id = 'gems';
        self.gems = newAdventure.summary.property('gems');
        self.inventory = newAdventure.inventory;

        self.inventorySpaces = ko.pureComputed(function () {
            var currentInventory = self.inventory(),
                emptyItem = {
                    name: ''
                },
                result = [],
                i;

            if (currentInventory.length < 4) {
                for (i = 0; i < (4 - currentInventory.length); i++) {
                    result.push(_.assignIn({}, emptyItem));
                }
            }

            return result;
        });

        self.useItem = function (item) {
            itemManager.useItem(item);
        };

        self.viewSmall = 'features/overlayGameLauncher/stats/gems/gemsViewSmall.html';
        self.viewLarge = 'features/overlayGameLauncher/stats/gems/gemsViewLarge.html';

        self.changeViewToShop = function () {
            // Maybe this could be moved as an event?
            parentView.changeCurrentScreenToById('shop');
        };

    };
});

